import { Provider } from '@angular/core';
import {
  JwtHelperService as Provide,
  JwtHelperService as Value,
} from '@auth0/angular-jwt';

export const JwtHelperServiceProvider: Provider = {
  provide: Provide,
  useFactory() {
    return new Value();
  },
};
